// material-ui
import { styled } from '@mui/system';
import Card from '@mui/material/Card';

const FormCardStyled = styled(Card, {
	shouldForwardProp: (prop) => {
		return !['fullHeight'].includes(prop);
	},
})(({ theme, fullHeight }) => ({
	height: fullHeight ? '100%' : 'auto',
	scrollbarWidth: 'none',
	' form': {
		display: 'flex',
		flexDirection: 'column',
		height: fullHeight ? '100%' : 'auto',
	},
	' .MuiCardContent-root': {
		flexGrow: 1,
		overflow: fullHeight ? 'auto' : undefined,
		scrollbarWidth: 'none',
	},
	' .MuiCardActions-root': {
		borderTop: `1px solid ${theme.palette.divider}`,
	},
	' .MuiCardHeader-root': {
		borderBottom: `1px solid ${theme.palette.divider}`,
	}
}));

export default FormCardStyled;
